import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function DashboardMessageModal({
  isOpen,
  onClose,
  messageForm,
  setMessageForm,
  onReset,
  onSave,
}) {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/40 backdrop-blur-md flex items-center justify-center z-[9999] p-4" onClick={onClose}>
      <div className="bg-white/95 backdrop-blur-xl rounded-[2.5rem] p-8 w-full max-w-sm shadow-2xl border border-white/50" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold text-[#2C3E30]">배너 문구 수정</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="text-xs font-bold text-gray-500 mb-1 block">내용</label>
            <textarea
              className="w-full border p-3 rounded-xl bg-[#F9F9F8] focus:bg-white focus:ring-2 focus:ring-[#354F38]/20 outline-none transition resize-none h-24"
              value={messageForm.text}
              onChange={(e) => setMessageForm({ ...messageForm, text: e.target.value })}
              placeholder="말씀, 명언, 메모 등을 입력하세요"
            />
          </div>
          <div>
            <label className="text-xs font-bold text-gray-500 mb-1 block">출처 (선택)</label>
            <input
              className="w-full border p-3 rounded-xl bg-[#F9F9F8] focus:bg-white focus:ring-2 focus:ring-[#354F38]/20 outline-none transition"
              value={messageForm.source}
              onChange={(e) => setMessageForm({ ...messageForm, source: e.target.value })}
              placeholder="예: 요한복음 3:16"
            />
          </div>
          <div className="flex gap-2 pt-2">
            <button onClick={onReset} className="flex-1 py-3 border border-gray-200 text-gray-500 rounded-xl font-bold hover:bg-gray-50 transition text-sm">기본 말씀 사용</button>
            <button onClick={onSave} className="flex-1 py-3 bg-[#354F38] text-white rounded-xl font-bold hover:bg-[#2C3E30] transition shadow-lg shadow-[#354F38]/20">저장</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
